import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';

import { AngularEditorConfig } from '@kolkov/angular-editor';
import { AuthService } from '../../../services/auth.service';
import { EnvService } from '../../../services/env.service';
import { CommonService } from '../../../services/common.service';

@Component({
	selector: 'app-privacy',
	templateUrl: './privacy.component.html',
	styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent implements OnInit {

	admPageObj:any = "curr";

	logi_user:any;

	frm : FormGroup;

	editorConfig: AngularEditorConfig = {
			editable: true,
			spellcheck: true,
			height: '400px',
			minHeight: '15rm',
			width: 'auto',
			minWidth: '0',
			translate: 'no',
			showToolbar: true,
			placeholder: '내용을 입력하세요.',
			defaultParagraphSeparator: '',
			defaultFontName: '',
			defaultFontSize: '',
			fonts: [
				{class: 'arial', name: 'Arial'},
				{class: 'times-new-roman', name: 'Times New Roman'},
				{class: 'calibri', name: 'Calibri'},
				{class: 'comic-sans-ms', name: 'Comic Sans MS'}
			],
			sanitize: true,
			toolbarPosition: 'top',
	};

	constructor(
		private http: HttpClient,
		private fb: FormBuilder,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) {
		this.frm = fb.group({
			text: [''],
		});
	}

	ngOnInit() {
		this.getPrivacy();
	}

	async getPrivacy() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);

		this.http.post(this.env.API_URL + 'api/privacy.data.php', formData).subscribe((response) => {
			this.frm.get('text').setValue(response['text']);
		});
	}

	async regForm() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);

		formData.append("text", this.frm.get('text').value);

		this.func.prcLoading();

		this.http.post(this.env.API_URL + 'api/privacy.process.php', formData).subscribe((response) => {
			this.func.closeLoading();
		});
	}
}
